module.exports = __webpack_public_path__ + "img/client_1.c21b5122.gif";